import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useReducer, useState } from 'react';
import { useRouter } from 'next/router';

export default function Comp() {
    const { t } = useLang('powerBank.H');
    const { locale = 'us' } = useRouter();
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762506728114/Frame%201612707672.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1747908980907/Frame%201612707500.jpg',
        pad:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762506728114/Frame%201612707672.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1747908980907/Frame%201612707500.jpg',
        h5:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762744634909/m%20new%2003.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1747910656234/Frame%201612707562.jpg',
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
        theme: 'white',
    };
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secneH = AniContainer.create({
                triggerElement: '.Rapid-G',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secneH.destroy();
            };
        }
    }, []);
    return (
        <div className={`${styles.comp} Rapid-H GtmModuleData-section`} data-section-id="Rapid-H">
            {load && <EcoBanner {...dataA} />}
        </div>
    );
}
